import { Button } from "@vjal/ui";
import { useId } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { evaluateRouteAccess } from "../domain/capabilities";
import type { CoachingRole } from "../domain/roles";
import { DisabledControlReason } from "./AccessState";

export function RouteActionButton({
  label,
  path,
  role,
  variant = "primary"
}: {
  label: string;
  path: string;
  role: CoachingRole;
  variant?: "primary" | "secondary";
}) {
  const reasonId = useId();
  const navigate = useNavigate();
  const location = useLocation();
  const decision = evaluateRouteAccess(role, path);
  const disabled = !decision.allowed;

  return (
    <div className="grid gap-2">
      <Button
        type="button"
        variant={variant}
        disabled={disabled}
        aria-describedby={disabled ? reasonId : undefined}
        onClick={() => navigate(buildRolePath(path, role, location.search))}
      >
        {label}
      </Button>
      {disabled ? <DisabledControlReason id={reasonId}>{decision.reason}</DisabledControlReason> : null}
    </div>
  );
}

/** `path` for the next route; keeps the active evidence `?role=` when the current URL carries one. */
export function buildRolePath(path: string, role: CoachingRole, search: string) {
  const next = new URL(path, window.location.origin);
  if (new URLSearchParams(search).has("role")) {
    next.searchParams.set("role", role);
  }
  return `${next.pathname}${next.search}`;
}
